import SubdirectoryArrowRightOutlined from '@mui/icons-material/SubdirectoryArrowRightOutlined';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import type { OrganizationParentAccount } from '../../../../types.ts';

export type AccountHierarchyPreviewProps = {
  selectedParentAccount: OrganizationParentAccount;
};

const newOrganizationPlaceholder: OrganizationParentAccount = {
  id: 'placeholder-organization',
  name: 'Creating Organization',
  parentOrganization: [],
};

const getItemPaddingLeft = (depth: number): number => (depth > 1 ? (depth - 1) * 2.5 : 0);

export const AccountHierarchyPreview = ({ selectedParentAccount }: AccountHierarchyPreviewProps) => {
  const { t } = useTranslation();
  const accountHierarchy = [...(selectedParentAccount?.parentOrganization ?? []), selectedParentAccount];
  const accountHierarchyWithPlaceholder = [
    ...accountHierarchy,
    { ...newOrganizationPlaceholder, depth: accountHierarchy.length },
  ];

  return (
    <Grid
      data-test="account-hierarchy-preview"
      size={4}
      sx={{ borderLeft: theme => `2px solid ${theme.palette.divider}`, ml: 2, pb: 1, pl: 2, height: 'fit-content' }}
    >
      <Typography sx={{ mb: 2 }}>
        {t(
          'All users who have access to any of the parent organizations will automatically have access to this new organization.'
        )}
      </Typography>

      {accountHierarchyWithPlaceholder.map(({ id, name, depth = 0 }) => (
        <Stack
          key={id}
          data-test="account-hierarchy-preview-item"
          direction="row"
          spacing={0}
          sx={{ alignItems: 'center', mt: '0 !important', pl: getItemPaddingLeft(depth) }}
        >
          {depth > 0 && <SubdirectoryArrowRightOutlined color="action" fontSize="small" />}
          <Typography sx={{ fontWeight: id === 'placeholder-organization' ? 'fontWeightBold' : 'normal' }}>
            {name}
          </Typography>
        </Stack>
      ))}
    </Grid>
  );
};
